module.exports = __webpack_public_path__ + "static/media/1-people.d804f9bc.svg";